"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var changeCase_1 = require("../utils/changeCase");
var element_1 = require("../utils/element");
exports.KSYS_GLOBAL_VARIABLES_WINDOW_KEY = '__ksysGlobalVariables__';
var AppParamsHelper = /** @class */ (function () {
    function AppParamsHelper(element, url) {
        this.values = {};
        this.element = element;
        this.url = url;
        this.rawAppParams = this.getAppParamsFromElement();
        this.loadValues();
    }
    AppParamsHelper.prototype.loadValues = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appParamRequestItems, appParamInstances, _i, appParamInstances_1, item, type, instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadInputs();
                        appParamRequestItems = this.getAppParamRequestItems(AppParamsHelper.types, this.rawAppParams);
                        return [4 /*yield*/, this.fetchAppParamInstances(appParamRequestItems)];
                    case 1:
                        appParamInstances = _a.sent();
                        for (_i = 0, appParamInstances_1 = appParamInstances; _i < appParamInstances_1.length; _i++) {
                            item = appParamInstances_1[_i];
                            type = item.type, instance = item.instance;
                            if (!this.values) {
                                this.values = {};
                            }
                            this.values[type] = instance;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AppParamsHelper.prototype.getAppParamRequestItems = function (types, rawAppParams) {
        var response = [];
        for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
            var type = types_1[_i];
            var instanceKey = type + "Instance";
            var keyKey = type + "Key";
            if (!rawAppParams[instanceKey]) {
                if (rawAppParams[keyKey]) {
                    response.push({
                        type: type,
                        key: rawAppParams[keyKey],
                    });
                }
            }
            else {
                if (!this.values) {
                    this.values = {};
                }
                this.values[type] = rawAppParams[instanceKey];
            }
        }
        return response;
    };
    AppParamsHelper.prototype.loadInputs = function () {
        this.staticInputs = this.loadPrefixedFieldsFromElement('input', 'inputs', this.rawAppParams);
    };
    AppParamsHelper.prototype.loadInputsFromConfiguration = function (inputs) {
        // The order is important to let the existing values take precedence as they would be explicit
        this.values.inputs = __assign(__assign(__assign({}, (this.values.inputs || {})), inputs), (this.staticInputs || {}));
    };
    AppParamsHelper.prototype.loadPrefixedFieldsFromElement = function (prefix, valuesKey, rawAppParams) {
        var keys = Object.keys(rawAppParams || {}).filter(function (key) { return key.startsWith(prefix); });
        var values = keys.reduce(function (acc, key) {
            var value = rawAppParams[key];
            var newKey = changeCase_1.camelCase(key.substr(prefix.length));
            acc[newKey] = value;
            return acc;
        }, {});
        this.values[valuesKey] = values;
        return this.values[valuesKey];
    };
    AppParamsHelper.prototype.getAppParamsFromElement = function () {
        return element_1.getOrchestratedDataset(this.element);
    };
    AppParamsHelper.prototype.getParamInstance = function (type) {
        var rawInstance = type + "Raw";
        if (rawInstance) {
            return rawInstance;
        }
        var key = type + "Key";
    };
    AppParamsHelper.prototype.fetchAppParamInstances = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // DUMMY DATA
                return [2 /*return*/, items.map(function (item) {
                        return Object.assign({}, item, {
                            instance: {},
                        });
                    })];
            });
        });
    };
    Object.defineProperty(AppParamsHelper.prototype, "inputs", {
        get: function () {
            var response = {};
            var configuration = this.configuration;
            if (configuration) {
                // THIS MUST BE CONVERTED TO USE THE INPUTS ON THE APPLICATION INSTANCE
                // const { inputMapping = {}, inputs } = configuration;
                // const { urlFormat = '' } = inputMapping || {} as IInputMapping;
                // const inputsByMappingId = pivotCollection(inputs && inputs.values, element => element.inputMappingId);
                // (inputMapping.mappings || []).forEach((mappingItem) => {
                // 	const { id } = mappingItem;
                // 	const existingInput = inputsByMappingId[id];
                // 	if (existingInput) {
                // 		response[id] = existingInput.value;
                // 	}
                // 	else {
                // 		if (mappingItem.type === 'queryString') {
                // 			response[id] = getQueryStringValue(mappingItem.mapping, this.url);
                // 		}
                // 		else if (mappingItem.type === 'url') {
                // 			response[id] = getUrlValueFromFormat(mappingItem.mapping, urlFormat, this.url);
                // 		}
                // 		else if (mappingItem.type === 'hardCoded') {
                // 			if (mappingItem.mapping && mappingItem.mapping.value) {
                // 				response[id] = mappingItem.mapping.value;
                // 			}
                // 		}
                // 		else if (mappingItem.type === 'global') {
                // 			response[id] = getGlobalValue(mappingItem.mapping);
                // 		}
                // 	}
                // });
            }
            return Object.assign(response, (this.values && this.values.inputs) || {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppParamsHelper.prototype, "configuration", {
        get: function () {
            return this.values && this.values.configuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppParamsHelper.prototype, "theme", {
        get: function () {
            return this.values && this.values.theme;
        },
        enumerable: true,
        configurable: true
    });
    AppParamsHelper.types = ['configuration', 'theme'];
    return AppParamsHelper;
}());
exports.AppParamsHelper = AppParamsHelper;
//# sourceMappingURL=AppParamsHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/AppParamsHelper.js
// module id = 203
// module chunks = 1